import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const columnsCategoryBlanceXS = [
    {
        dataField: 'id',
        text: 'Detalle',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Tipo Recibo:' value={row.receipt_type} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]
export const columnsCategoryBlanceSM = [
    {
        dataField: 'id',
        hidden: true
    },
    {
        dataField: 'receipt_type',
        text: 'Tipo Recibo'
    },
    {
        dataField: 'quantity',
        text: 'Cantidad'
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];

export const columnsCategorySellsXS = [
    {
        dataField: 'id',
        hidden: true
    },
    {
        dataField: 'xs',
        text: 'Ventas ',
        formatter: (cell, row) => {

            return (
                <div>
                    <TableRowField label='Cliente:' value={`${row.customer}`} />
                    <TableRowField label='Tipo Recibo:' value={row.payment} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]

export const columnsCategorySellsSM = [
    {
        dataField: 'id',
        hidden: true
    },
    {
        dataField: 'xs',
        text: 'Detalle',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Cliente:' value={`${row.customer}`} />
                </div>
            )
        },
        headerStyle: { width: '47%' }
    },
    {
        dataField: 'payment',
        text: 'Tipo Recibo',
        style: { width: '18%' },
        headerStyle: { width: '18%' }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        },
        style: { width: '15%' },
        headerStyle: { width: '15%' }
    }
];

export const columnsCategorySellsMD = [
    {
        dataField: 'id',
        hidden: true
    },
    {
        dataField: 'customer',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} `}</span>
            )
        }
    },
    {
        dataField: 'payment',
        text: 'Tipo Recibo'
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    },
];


// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ReceiptBalance/_columns.js